export default "__VITE_ASSET__e914ce1a__"